
import K9SeatEntityBase from "./k9_seat_entity_base";
import { K9 } from "./k9_data";

const {ccclass, property} = cc._decorator;

@ccclass
export default class K9SeatEntity extends K9SeatEntityBase {

    updateEntity(v_id:number,ispos:boolean = true,func:Function = null){
        super.updateEntity(v_id,ispos);
        let data = this.getData(v_id,ispos);
        if (!data) {
            return;
        }
        let state = data.state;
        this.isShowMask(data.seat_pos,state == K9.PlayerState.NoInGame);
    }


}
